<script>
import moment from 'moment'

export default {
  methods: {
    timeFormat (time) {
      // eslint-disable-next-line
      const start = moment(time.start),
        end = moment(time.end),
        startYear = start.format('YY'),
        endYear = end.format('YY')

      if (startYear === endYear) {
        return `van ${start.format('DD-MM')} / ${end.format('DD-MM-YYYY')}`
      } else {
        return `van ${start.format('DD-MM-YYYY')} / ${end.format('DD-MM-YYYY')}`
      }
    },
    priceFormat (price) {
      const formatter = new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2
      })
      return formatter.format(price)
    }
  }
}
</script>
